// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This style file is imported by VersionDownload.js which is called by PltVersionTable.js, CsVersionTable.js file.
*/

.download-version-button {
    background-color: #0C3135;
    height: 2.0rem !important; 
    width: 2.0rem; 
    color: white;
    padding: 8px 16px;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s ease;
    margin: 0px 0;  
    margin-top: 0px;
    float: right;   
    margin-right: 1px; 
    font-size: 0.8rem;
    padding-top:0.8%;
    padding-left: 1%;
    padding-bottom: 1% !important;
    padding-right: 1%;
    border-radius: 8px;
}

.download-version-button:hover {
    background-color: #2a5a5a;
}
`, "",{"version":3,"sources":["webpack://./src/components/Download/VersionDownload.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;IACI,yBAAyB;IACzB,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,aAAa;IACb,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/*\nThis style file is imported by VersionDownload.js which is called by PltVersionTable.js, CsVersionTable.js file.\n*/\n\n.download-version-button {\n    background-color: #0C3135;\n    height: 2.0rem !important; \n    width: 2.0rem; \n    color: white;\n    padding: 8px 16px;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s ease;\n    margin: 0px 0;  \n    margin-top: 0px;\n    float: right;   \n    margin-right: 1px; \n    font-size: 0.8rem;\n    padding-top:0.8%;\n    padding-left: 1%;\n    padding-bottom: 1% !important;\n    padding-right: 1%;\n    border-radius: 8px;\n}\n\n.download-version-button:hover {\n    background-color: #2a5a5a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
